import { createApp } from 'vue';
import RegistrationRoleSelect from './../components/register/RegistrationRoleSelect';

if (document.getElementById('register-app')) {
    const app = createApp({
        components: {
            'registration-role-select': RegistrationRoleSelect
        }
      });
    
    app.mount('#register-app');
}
